import { empApi } from "./client";

// Danh sách booking -> { items, pagination }
export const getBookingListApi = (params) => empApi.get("/booking/app", params);

// Chi tiết booking
export const getBookingByIdApi = (id) => empApi.get(`/booking/app/${id}`);

// Tạo booking
export const createBookingApi = (body) => empApi.post("/booking/app", body);

// Cập nhật / Xóa / Hoàn / Chuyển booking
export const updateBookingApi = (id, body) => empApi.put(`/booking/app/${id}`, body);
export const deleteBookingApi = (id) => empApi.del(`/booking/app/${id}`);
export const refundBookingApi = (id) => empApi.put(`/booking/app/pendingReturnRequest/${id}`, { status: "PENDINGRETURNREQUEST" });
export const transferBookingApi = (id, body) => empApi.post(`/booking/app/transfer/${id}`, body);

// Tìm nhân viên (dùng cho chuyển booking) -> { items }
export const searchEmployeeApi = (params) => empApi.get("/employee/search", params);
